window.OverviewAnimation = Backbone.Model.extend({
    // no instance functionality
}, {
    animateIn: function(target) {
        TweenMax.fromTo(target, 0.5, {
            scale: 0.95,
            opacity: 0.5,
        }, {
            scale: 1,
            opacity: 1,
            ease: Power4.easeOut,
            delay: 0.3,
            immediateRender: false
        });
    }
});
